export const messages = {
    en: {
        sign_view: {
            unauthorized_error: 'Unauthorized. Something went wrong, please, try again later'
        },
        sign_up_view: {
            fatal_error: 'Something went wrong, please, try again later'
        },
        forgot_view: {
            fatal_error: 'Something went wrong, please, try again later'
        },
        reset_password_view: {
            fatal_error: 'Something went wrong, please, try again later'
        },
        confirm_view: {
            fatal_error: 'Something went wrong, please, try again later'
        },
        cars_view: {
            manufacturers_loading_error: 'Something went wrong during loading manufacturer filters, please try again later',
            models_loading_error: 'Something went wrong during loading model filters, please try again later',
            generations_loading_error: 'Something went wrong during loading generation filters, please try again later',
            wheel_drives_loading_error: 'Something went wrong during loading wheel drives filters, please try again later',
            specifications_loading_error: 'Something went wrong during loading specifications filters, please try again later',
            fuels_loading_error: 'Something went wrong during loading fuel filters, please try again later',
            transmissions_loading_error: 'Something went wrong during loading transmission filters, please try again later',
            cars_loading_error: 'Something went wrong during loading cars, please try again later'
        },
        car_view: {
            car_loading_error: 'Something went wrong during loading car details, please try again later',
            cars_ads_loading_error: 'Something went wrong during loading similar cars. Please try again later',
            cars_ads_empty: 'All similar cars available displayed. For more options, please, open the main page'
        },
        profile_view: {
            profile_loading_error: 'Something went wrong during loading user profile, please try again later',
            profile_editing_error: 'Something went wrong during editing user profile, please try again later',
            changing_password_error: 'Something went wrong during changing password, please try again later'
        },
        user_orders_view: {
            orders_loading_error: 'Something went wrong during loading orders, please try again later'
        },
        user_order_view: {
            order_loading_error: 'Something went wrong during loading order, please try again later',
            cancellation_error: 'Something went wrong during order cancellation, please try again later or contact your manager'
        },
        user_invoices_view: {
            invoices_loading_error: 'Something went wrong during loading invoices, please try again later',
            file_loading_error: 'Something went wrong during loading invoice file, please try again later',
            invoice_loading_error: 'Something went wrong during loading invoice verification data, please try again later',
            items_amount_error: 'You have to add at least one item to the list',
            invoice_creation_error: 'Something went wrong during invoice creation, please try again later'
        },
        payments_view: {
            payments_loading_error: 'Something went wrong during loading payments history, please try again later',
            statistic_loading_error: 'Something went wrong during loading account statistics, please try again later'
        },
        admin_orders_view: {
            manufacturers_loading_error: 'Something went wrong during loading manufacturer filters, please try again later',
            models_loading_error: 'Something went wrong during loading model filters, please try again later',
            fuels_loading_error: 'Something went wrong during loading fuel filters, please try again later',
            transmissions_loading_error: 'Something went wrong during loading transmission filters, please try again later',
            requests_loading_error: 'Something went wrong during loading requests, please try again later'
        },
        admin_order_view: {
            order_loading_error: 'Something went wrong during loading order, please try again later',
            calculation_saving_error: 'Something went wrong during saving order calculation, please try again later'
        },
        accountant_user_list_view: {
            users_loading_error: 'Something went wrong during loading users, please try again later'
        },
        accountant_user_view: {
            user_loading_error: 'Something went wrong during loading user info, please try again later',
            payments_loading_error: 'Something went wrong during loading payments history, please try again later',
            statistic_loading_error: 'Something went wrong during loading account statistics, please try again later',
            payment_creation_error: 'Something went wrong during payment creation, please try again later'
        }
    }
}
